import { render, staticRenderFns } from "./VehicleRequestOrganisationTypeCount.vue?vue&type=template&id=0cab9806&"
import script from "./VehicleRequestOrganisationTypeCount.vue?vue&type=script&lang=js&"
export * from "./VehicleRequestOrganisationTypeCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports